/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../payments/push_money';
import '../common/common';
import '../../payments/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "PushMoneyIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "senderInfo": {
                    "type": "squareup.payments.pushmoney.SenderInfo",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PushMoneyResult": {
                "fields": {
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failureReasons": {
                    "type": "squareup.payments.pushmoney.PushMoneyError",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "approvalCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "autoVoid": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "accountUpdaterResult": {
                    "type": "squareup.esperanto.common.AccountUpdaterResult",
                    "id": 5,
                    "rule": "optional"
                  },
                  "gatewayAccountNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": "squareup.payments.common.CardNetwork",
                    "id": 7,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": "squareup.payments.common.AcquiringEntity",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PushMoneyIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PushMoneyResult) {
  $root.addJSON(jsonData);
}

/**
 * PushMoney intent.
 *
 * SOURCE PushMoneyIntent @ squareup/esperanto/model/push_money.proto at 16:1
 */
export const PushMoneyIntent = $root.lookupType('squareup.esperanto.model.PushMoneyIntent');
fixType(PushMoneyIntent);
Builder.createAndAttachToType(PushMoneyIntent);
/**
 * PushMoney result.
 *
 * SOURCE PushMoneyResult @ squareup/esperanto/model/push_money.proto at 30:1
 */
export const PushMoneyResult = $root.lookupType('squareup.esperanto.model.PushMoneyResult');
fixType(PushMoneyResult);
Builder.createAndAttachToType(PushMoneyResult);